var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBandsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Cellist",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-191 65 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: -139.3,
    cy: 162.1,
    r: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -140.1,
    y: 233.6,
    transform: "matrix(0.9397 0.342 -0.342 0.9397 72.4811 59.3574)",
    width: 16,
    height: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.6,215.2c1.6,0,3-0.7,4.1-1.7l17.6,6.5v11.4h-8.1c-2.1,0-4.1,0.8-5.6,2.4c-1.6,1.6-2.4,3.7-2.4,5.6v39 c0,4.5,3.6,8.1,8.1,8.1c4.5,0,8.1-3.6,8.1-8.1v-16c2.8,3.2,6.2,6,10.5,7.7l-5.4,14.8l3,1.2l5.4-15c2.8,0.8,5.6,1.3,8.3,1.3 c3.6,0,6.9-0.7,10.1-2c1.3-0.5,2.4-1.2,3.6-1.7v9.6c0,4.5,3.6,8.1,8.1,8.1s8.1-3.6,8.1-8.1l-0.3-39.2c0-2.1-0.8-4.1-2.4-5.6 c-1.6-1.6-3.6-2.3-5.6-2.4c1.5-2.1,3.8-3.8,6.6-4.6l0.5-0.1l0.3-0.3c2-2,3.2-4.1,4.1-6.8c2.3-6.1,1.2-12.6-2.3-17.9h0.1l0.7,1.2 c1.5,2.8,4.8,3.8,7.5,2.4c2.8-1.2,3.9-4.5,2.4-7.3l-11.5-22.9c-0.5-1.2-1.3-2-2.3-2.4l1.2-3l3,1.2l3.2-15.9l-0.8-0.3l-1.4-0.6 l-2.4-0.8l-7.7,14.2l3,1.2l-1.3,3.6c-0.7,0-1.5,0.3-2.1,0.7c-2.8,1.5-3.8,4.8-2.4,7.5l0.9,1.7l-0.5,1.3c-3.2-3-7.3-4.6-11.4-4.6 h-52.4c-3,0-5.6,2.5-5.6,5.6v25.7C-184.2,212.6-181.7,215.2-178.6,215.2z M-142.1,225.1l20.7,7.5l1.2-3l-20.7-7.5 c0.8-3.7,0.1-7.7-2.1-11.1c-0.1-2.1,0.1-4.1,0.9-6.1c3.2-8.6,13.4-13.1,23.2-10.3l-9.8,26.9l3,1.2l9.8-27.1 c9.2,4.1,14.2,13.9,11,22.7c-0.7,2-1.7,3.7-3.2,5.3c-4.5,1.5-8.1,4.6-9.5,8.9c-2,5.4-0.5,11.5,4,15.9c0.1,2.5-0.1,5-1.2,7.4 c-2,5.2-6,9.3-11.4,11.5c-5,2.1-10.7,2.3-16,0.7l10.3-28.1l-3-1.2l-10.3,28.1c-11.1-4.8-17.1-16.5-13.4-27c0.8-2.4,2.1-4.5,3.8-6.2 C-149.2,233.2-144.3,230-142.1,225.1z M-173,209.5v-20.1h16v26.9l-16.1-5.9C-173.2,210-173,209.7-173,209.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 167,
    transform: "matrix(0.9659 0.2588 -0.2588 0.9659 48.1219 2.0449)",
    width: 3.5,
    height: 33.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -28.4,
    cy: 163.1,
    r: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-60.8,246.5c0.7,0.1,1.4,0.1,2.2,0.1h30.8l12.3,26.2c2.1,4.3,7.1,6,11.4,4.2c4.2-2.4,6.1-7.5,4-12l-14.5-30.8 c-1.4-3.1-4.6-5-7.8-5h-17.3v-10.3h-6c-5.2,0-9.5-4.3-9.5-9.5v-15.3c0-1,0.7-1.7,1.7-1.7s1.7,0.7,1.7,1.7v15.3c0,3.2,2.8,6,6,6 h26.2c0.8-5,3.8-9.3,7.8-12h-27.9V182c0-3.1-2.2-5.6-5.3-6c-1-0.1-2.1-0.1-3.2,0c-11.8,0.8-23.7,10.4-25.4,23.1 c-1.4,11.1-1.7,23.7-0.6,34.4C-73.1,240.1-67.9,245.5-60.8,246.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -74.1,
    y: 263.5,
    fill: "none",
    width: 38.6,
    height: 23.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9,
    y: 224.1,
    fill: "none",
    width: 6.8,
    height: 52.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,143.7v-8.9h-0.8H20.5v5.2v3.7h5.2v59.8H-0.9c-8.6,0-15.5,6.8-15.5,15.5v5.2H12v52.1H4c-3.1,0-5.7,2.6-5.7,5.7v2.2H12 v2.5h-41.7v-30.3c0.1-3.6-2.4-6.5-5.5-6.5h-39.2c-3.1,0-5.6,2.9-5.6,6.5v30.3h-111V321H65v-34.3h-5.9v-143H65z M-35.5,286.7h-38.6 v-23.2h38.6V286.7z M25.7,276.2h-6.8v-52.1h6.8V276.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandsite);
export default __webpack_public_path__ + "static/media/bandsite.02c34ed20859b9016dc342f8c2d44109.svg";
export { ForwardRef as ReactComponent };